.tabs {
  --tab-inner-border-radius: var(--radius-4);

  & :global(.rt-TabNavLinkInner),
  & :global(.rt-TabNavLinkInnerHidden) {
    font-weight: var(--font-weight-regular);
  }
}

.tabsSize1 {
  --tab-inner-padding-y: var(--fly-number-spacing-2);
  --tab-inner-padding-x: var(--fly-number-spacing-2);

  & :global(.rt-TabNavLinkInner),
  & :global(.rt-TabNavLinkInnerHidden) {
    height: 20px;
  }
}

.tabsSize2 {
  --tab-inner-padding-y: var(--fly-number-spacing-3);
  --tab-inner-padding-x: var(--fly-number-spacing-3);

  & :global(.rt-TabNavLinkInner),
  & :global(.rt-TabNavLinkInnerHidden) {
    height: 28px;
  }
}

.tabsSize3 {
  --tab-inner-padding-y: var(--fly-number-spacing-3);
  --tab-inner-padding-x: var(--fly-number-spacing-3);

  --tab-height: 56px;

  & :global(.rt-TabNavLinkInner),
  & :global(.rt-TabNavLinkInnerHidden) {
    height: 28px;
  }
}
